function $on(name, cb) {
    window.addEventListener(name, (e) => cb(e.detail));
}

function $emit(name, data) {
    window.dispatchEvent(new CustomEvent(name, { detail: data }));
}

function $off(name, cb) {
    window.removeEventListener(name, cb);
}

export default {
    $on,
    $emit,
}
